import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    faBars,
    faCheckDouble,
    faCircle,
    faCopy,
    faEye,
    faFileCirclePlus,
    faSort,
    faSortDown,
    faSortUp,
    faTrash,
    faUpRightFromSquare
} from '@fortawesome/free-solid-svg-icons';
import {Link} from "react-router-dom";
import Toman from "../Utilities/Toman";
import React, {useState} from "react";
import {
    formatNumberWithDots,
    getDateAsReadableFormat,
    getFrontEndUrl,
    hasClickAction,
    storeClickAction
} from "../../helper/general";
import moment from "jalali-moment";
import ApiRoute from "../../helper/api";
import {faSortAsc} from "@fortawesome/free-solid-svg-icons/faSortAsc";
import {faSortDesc} from "@fortawesome/free-solid-svg-icons/faSortDesc";
import ProductCloneModal from "../Product/Modal/ProductCloneModal";
import LogProductSidebar from '../Common/LogProductSidebar';


function ProductList({tableData,setUpdateData,onSort}) {
    console.log(tableData);
    const [tableTitles,setTableTitles] = useState([
        {title:'نام کالا'},
        {title:'SKU'},
/*         {
            title:'وضعیت',
            name:"status",
            dir:"desc",
            sort:true
        }, */
        {
            title:'موجودی',
            name:"stock_status",
            dir:"desc",
            sort:false
        },
        {
            title:'ایجاد',
            name:"created_at",
            sort:true
        },
        {
            title: 'انتشار',
            name:"publish_at",
            sort: true
        },
        {
            title:'بروزرسانی',
            name:"updated_at",
            sort:true
        }
    ])
    const [update , setUpdate] = useState(0)
    const [cloneModalProduct, setCloneModalProduct] = useState(null);

    const [isLogSidebarOpen, setIsLogSidebarOpen] = useState(false);
    const [selectedProductLogs, setSelectedProductLogs] = useState(null);

    const openLogSidebar = (product) => {
        setSelectedProductLogs(product);
        setIsLogSidebarOpen(true);
    };

    const closeLogSidebar = () => {
        setIsLogSidebarOpen(false);
        setSelectedProductLogs(null);
    };

    async function handleClone(product) {
        await ApiRoute.product.clone.fn(product._id)
        setUpdateData(Date.now().toString())
    }

    return (
        <>
            <table className="table-auto w-full block lg:table mt-4">
                <thead>
                <tr className="border-b border-b-gray-7">
                    {tableTitles.map((item, id) => (
                        <td onClick={ () => {
                            if (item.sort !== true) return;
                            let dir = localStorage.getItem("sort_dir") ?? "desc";
                            if ( dir === "desc" ){
                                localStorage.setItem("sort_dir", "asc")
                            }else{
                                localStorage.setItem("sort_dir", "desc")
                            }
                            onSort(item.name , dir)
                        } } className={ (item.sort && 'cursor-pointer text-purple-1') +` text-13 relative text-gray-6 pb-2`} key={id}>
                           {item.title}
                            {item.sort && <FontAwesomeIcon className={`mr-2`} icon={faSort}/>}
                        </td>
                    ))}
                    <td></td>
                </tr>
                </thead>
                <tbody>
                {tableData.map(_tableData => (
                        <tr className={`text-[15px] py-2`} key={_tableData.id}>
                            <td><span className="text-right inline-table">
                                <Link className={( hasClickAction(`product_edit_${_tableData._id}`) ? ' text-purple-1 ' : '' )+`hover:text-purple-1 font-normal`} onClick={ () => { storeClickAction(`product_edit_${_tableData._id}`) } } to={`/products/edit?product_id=${_tableData._id}`} title="مشاهده و ویرایش">
                                    {_tableData.title}
                                    {_tableData.status === "draft" ? (<i className={`text-red-2 mx-1`}>(پیشنویس)</i>) : ''}
                                    {_tableData?.sku && _tableData.sku.toLowerCase().includes("khno-") ? (<i className={`text-blue-4 mx-1`}>(خانگینو)</i>) : ''}
                                </Link>
                            </span>
                            </td>
                            <td>{_tableData.sku}</td>
{/*                         <td>
                                {_tableData.status == "publish" && <FontAwesomeIcon className={`text-lg text-green-1`}
                                                                                    icon={faCircle}/>}
                                {_tableData.status == "draft" && <FontAwesomeIcon className={`text-lg text-yellow-2`}
                                                                                  icon={faCircle}/>}
                                {_tableData.status == "trash" && <FontAwesomeIcon className={`text-lg text-red-1`}
                                                                                  icon={faCircle}/>}
                            </td> */}
                            <td>
                                {_tableData.stocks.web_site > 1 && <FontAwesomeIcon className={`text-lg text-green-1`}
                                                                                    icon={faCircle}/>}
                                {_tableData.stocks.web_site == 1 && <FontAwesomeIcon className={`text-lg text-yellow-2`}
                                                                                  icon={faCircle}/>}
                                {_tableData.stocks.web_site == 0 && <FontAwesomeIcon className={`text-lg text-red-1`}
                                                                                  icon={faCircle}/>}
                            </td>
                            <td>
                                {getDateAsReadableFormat(_tableData.created_at)} <br/>
                                {_tableData.metadata?.created_by?.name ?? '--'}
                            </td>
                            <td>
                                {_tableData?.publish_at == null ? '--' : getDateAsReadableFormat(_tableData.publish_at)} <br/>
                                {_tableData.metadata?.published_by?.name ?? '--'}
                            </td>
                            <td>
                                {getDateAsReadableFormat(_tableData.updated_at)} <br/>
                                {_tableData.metadata?.updated_by?.name ?? '--'}
                            </td>
                            <td>
                                <div className="flex">
                                    <Link onClick={ () => {
                                        storeClickAction(`product_edit_${_tableData._id}`)
                                    } } className="mx-1" to={`/products/edit?product_id=${_tableData._id}`} title="مشاهده و ویرایش"><FontAwesomeIcon
                                        className={( hasClickAction(`product_edit_${_tableData._id}`) ? ' !bg-[#2f3133] ' : '' )+`bg-gray-5 text-white p-1 w-4 h-4 rounded`} icon={faEye}/></Link>


                                    { (_tableData.status == 'publish' || _tableData.status == 'private') && <a className="mx-1" href={getFrontEndUrl('/'+_tableData.slug,_tableData?.shop_id)} title="نمایش در سایت"><FontAwesomeIcon
                                        className="bg-green-1 text-white p-1 w-4 h-4 rounded" target="_blank" icon={faUpRightFromSquare}/></a>}

                                    { _tableData.status == 'draft' && <a className="mx-1" href={getFrontEndUrl('/product-preview/2de444cfc0617da224bd339ce8637136/'+_tableData._id,_tableData?.shop_id)} title="پیشنمایش در سایت"><FontAwesomeIcon
                                        className="bg-yellow-2 text-white p-1 w-4 h-4 rounded" target="_blank" icon={faUpRightFromSquare}/></a>}

                                    <button className="mx-1" onClick={() => setCloneModalProduct(_tableData)} title="کلون"><FontAwesomeIcon
                                        className="bg-purple-2 text-white p-1 w-4 h-4 rounded" icon={faCopy}/></button>

                                    <button onClick={ () => {
                                        openLogSidebar(_tableData);
                                    } } title="مشاهده لاگ‌ها"><FontAwesomeIcon
                                        className="bg-gray-5 text-white p-1 w-4 h-4 rounded" icon={faBars}/></button>

                                </div>

                            </td>
                        </tr>
                    )
                )}
                </tbody>
            </table>

            {cloneModalProduct && (
                <ProductCloneModal
                    product={cloneModalProduct}
                    closeModal={() => setCloneModalProduct(null)}
                    event={() => {
                        setUpdateData(Date.now().toString());
                        setCloneModalProduct(null);
                    }}
                />
            )}

            {/* کامپوننت سایدبار لاگ‌ها */}
            <LogProductSidebar
                isOpen={isLogSidebarOpen}
                onClose={closeLogSidebar}
                selectedProduct={selectedProductLogs}
            />

        </>
    )
}

export default ProductList